import { useEffect } from 'react';

function useSrcChanged(src, audioRef, seek, setSpeed, setError) {
  useEffect(function () {
    var audio = audioRef.current; // Changing the src is overriding the pause event, so we are using setTimeout to overcome it.

    setTimeout(function () {
      audio.src = src;
    }, 0);
    return function () {
      setSpeed(1);
      audio.pause();
      setError(null);
    };
  }, [src, seek, audioRef, setSpeed, setError]);
}

export { useSrcChanged };